import React from "react";
import Main from "../common/Main/Main";

import { coming_soon } from "../constants/Images";

function ErrorPage() {
  return (
    <Main>
      <img src={coming_soon} />
    </Main>
  );
}
export default ErrorPage;
